import React from "react";
import { useTranslation } from "react-i18next";

const NavItems = ({ title, options }) => {
  const { t } = useTranslation();
  return (
    <li className="space-y-2">
      <p className="text-sm text-secondary-600 font-normal">{title}</p>
      <ul className="space-y-px">
        {options.map((item) => (
          <li
            key={item.title}
            className={`hover:bg-grey-100 p-3 rounded flex items-center gap-4 cursor-pointer `}
            onClick={item.action}
          >
            <item.icon className="w-6.5 h-6.5 flex-shrink-0" />
            <div className="flex flex-wrap gap-1 items-center">
              <span className="text-grey-300 md:text-base text-sm font-normal">
                {item.title}
              </span>
              {item.tag && (
                <span
                  className={`
              rounded-full py-1 px-2 text-xs uppercase font-normal
              ${
                item.tag === t("NEW")
                  ? "bg-danger-50 text-danger-300"
                  : "bg-success-100 text-success-1000"
              }
              `}
                >
                  {item.tag}
                </span>
              )}
            </div>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default NavItems;
